var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-branding",
      style: _setup.colorVarStyles,
      attrs: { "data-qa": "lpu_page_otzivi" },
    },
    [
      !_setup.isMobile
        ? _c(_setup.HeroSectionDesktop, {
            attrs: {
              lpu: _setup.context.lpu,
              "lpu-branding": _setup.context.lpu_branding,
              "lpu-video-card": _setup.context.lpu_video_card,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.CoreSnackbar),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }